import {
    Cancel,
    Visibility,
} from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
const columnShape = [
    {
        Header: 'No',
        accessor: 'number',
        maxWidth: 60,
        Cell: ({ row }) => {
            return <Box>{row.original.number || '-'}</Box>;
        },
    },
    {
        Header: 'Name',
        accessor: 'user.fullName',
        Cell: ({ row }) => {
            return (
                <Box>
                    <Box sx={{ fontWeight: 'bold' }}>
                        {row.original.user.fullName}
                    </Box>
                    <Box sx={{ color: 'text.disabled' }}>
                        {row.original.user.email}
                    </Box>
                </Box>
            )
        },
    },
    {
        Header: 'Title',
        accessor: 'title',
        minWidth: 300,
    },
    {
        Header: 'Presentation Type',
        accessor: 'presentationType',
        Cell: ({ row }) => {
            return (
                <Box>
                    <Typography>{row.original.presentationType?.label || '-'}</Typography>
                    {row.original.presentationType?.isDiscount ? (
                        <Box sx={{ color: 'text.disabled' }}>
                            (Discount Symposium 30%)
                        </Box>
                    ) : null}
                </Box>
            );
        },
    },
    {
        Header: 'Action',
        accessor: 'id',
        Cell: ({ row, handleDetail }) => {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Tooltip title="View">
                        <IconButton
                            onClick={() => handleDetail(row.original)}
                            sx={{
                                color: 'text.primary',
                                fontSize: 18,
                            }}
                        >
                            <Visibility />
                        </IconButton>
                    </Tooltip>
                </Box>
            );
        },
    },
];
export default columnShape;
